module.exports = __webpack_public_path__ + "static/img/product-14.a37afcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-14.png
// module id = vYrv
// module chunks = 0